import { API_URL, SITE } from "@api/constants";

export type InviteResponse = {
  message: String;
};

const inviteByLicense = async ({ code, email }): Promise<InviteResponse> => {
  const response = await fetch(`${API_URL}/license/invite/${code}/${email}`, {
    method: "GET",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
    },
  });

  const message = await response.text();

  return {
    message,
  };
};

export default inviteByLicense;
